import '../sass/style.sass';
import swiperInit from './modules/swiperInit';
import header from './modules/header';
import addToCartText from './modules/add-to-cart-button';
import modal from './modules/modal';
import openSuccessModal from './modules/send-action';
import smallCategories from './modules/small-categories';
import oko from './modules/oko';



header();
addToCartText();
swiperInit();
modal();
openSuccessModal();
smallCategories();
oko();